export * from './delete-datei-art.component';
export * from './delete-datei-art.component.module';